import React, { useMemo, useState } from 'react';
import Footer from '../Footer';
import './styles/VirtualWalkPage.css';

const VirtualWalkPage = () => {
  const stops = useMemo(
    () => [
      {
        id: 'aula',
        title: 'Aula',
        url: 'https://webseta.hu/r1717268/aula_42/-738,76/3,43/100,00/',
      },
    ],
    []
  );

  const [index, setIndex] = useState(0);
  const current = stops[index];

  const next = () => setIndex((i) => (i + 1) % stops.length);
  const prev = () => setIndex((i) => (i - 1 + stops.length) % stops.length);

  return (
    <div className="virtual-walk-page">
      <div className="virtual-walk-container">
        <header className="virtual-walk-header">
          <h1>Virtuális séta</h1>
          <p>Fedezze fel az otthon tereit 360°-os nézetben.</p>
        </header>

        <div className="virtual-walk-view">
          <div className="virtual-walk-frame">
            <iframe
              key={current?.url}
              title={current?.title || 'Virtuális séta'}
              src={current?.url}
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />

            {stops.length > 1 && (
              <>
                <button
                  type="button"
                  className="virtual-walk-arrow virtual-walk-arrow--prev"
                  onClick={prev}
                  aria-label="Előző"
                >
                  ‹
                </button>
                <button
                  type="button"
                  className="virtual-walk-arrow virtual-walk-arrow--next"
                  onClick={next}
                  aria-label="Következő"
                >
                  ›
                </button>
              </>
            )}
          </div>

          <div className="virtual-walk-meta">
            <h2>{current?.title}</h2>
            {stops.length > 1 && (
              <p className="virtual-walk-step">
                {index + 1} / {stops.length}
              </p>
            )}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default VirtualWalkPage;
